import * as React from "react";
import { Tabs } from "antd";
import { useHistory, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

export const HomeTabs = ({
  userInfo,
  requestCount = 0,
  invitationCount = 0,
}) => {
  const history = useHistory();

  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const selectedTab = query.get("tab");

  const is_bank_user = userInfo?.is_bank_user;

  // const activeTab =
  return (
    <Tabs
      defaultActiveKey={selectedTab ?? "org"}
      onChange={(e) => {
        history.push(`?tab=${e}`);
      }}
    >
      <Tabs.TabPane tab="Your Organization" key="org" />

      {!is_bank_user && (
        <Tabs.TabPane
          tab={
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              Requests
              <CountView count={requestCount} />
            </div>
          }
          key="request"
        />
      )}

      <Tabs.TabPane
        tab={
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            Invitation
            <CountView count={invitationCount} />
          </div>
        }
        key="invitation"
      />
    </Tabs>
  );
};

const CountView = ({ count }) => {
  if (count === 0) {
    return null;
  }
  return (
    <span
      style={{
        height: "16px",
        width: "16px",
        borderRadius: "4px",
        background: "#143E9F",
        color: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "12px",
      }}
    >
      {count}
    </span>
  );
};
